import { Component, ChangeDetectorRef, ChangeDetectionStrategy, OnChanges, SimpleChanges } from "@angular/core";
import { BaseControlComponent } from "../base/base-control.component";
import { SelectorService } from "../base/selector.service";
@Component({
  selector: "ssg-checkbox",
  templateUrl: "checkbox.template.html",
  styleUrls: ["checkbox.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SepCheckboxComponent extends BaseControlComponent<string> implements OnChanges {
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  ngOnInit() {
    super.ngOnInit();
  }
  ngAfterViewChecked() {
    super.ngAfterViewChecked();
  }

  ngOnChanges(changes: SimpleChanges): void {}
  /**
   * keypress binding ngx way
   * @param evt
   */
  key(event) {
    if (this.disabled) return;
    if (event.code === "Space") {
      if (this.f[this.name].value) this.f[this.name].setValue(false);
      else {
        this.f[this.name].setValue(true);
      }
    }
  }
}
